import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState} from "react";
import {toast} from "react-toastify";
import {Button, Spinner} from "reactstrap";
import {documentApiService} from "../../query/documentApi.service";

type Props = {
  documentId: string;
  filename: string;
  label?: string;
};

/**
 * Download button — fetches a fresh presigned URL on click and opens it in a new tab.
 * We do not pre-fetch the URL on mount because the URL has a short lifetime (~10 min) and
 * the user may scroll the timeline for a while before clicking.
 */
export function DocumentDownloadAction({documentId, filename, label}: Props) {
  const [pending, setPending] = useState(false);

  return (
    <Button
      color="link"
      style={{textDecoration: "none"}}
      onClick={handleClick}
      disabled={pending}
      aria-label={`Télécharger ${filename}`}
    >
      {pending ? <Spinner size="sm" /> : <FontAwesomeIcon icon="download" />}
      {label && <>&nbsp;{label}</>}
    </Button>
  );

  async function handleClick() {
    try {
      setPending(true);
      const {downloadUrl} = await documentApiService.getDownloadUrl(documentId);
      window.open(downloadUrl, "_blank", "noopener");
    } catch {
      toast.error("Impossible d'ouvrir le fichier", {autoClose: 5000});
    } finally {
      setPending(false);
    }
  }
}
